import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import CONSTANT from '../../utils/constants';

import { clientMessage } from '../../utils/common';
import { onChange } from '../../common/actions';
import { logoutUser } from '../../controllers/switch-user';

class SwitchUser extends Component {
  state = {
    isProcessing: false
  };

  constructor(props) {
    super(props);
    this.label = clientMessage(CONSTANT.LOGIN.toLowerCase(), this.props.cache).label;
  }

  logoutUser = () => {
    this.setState({ isProcessing: true });
    const {
      cache,
      checkoutElementPayMode,
      onSelectChange,
      onLoginDataChange,
      onBtnTextChange
    } = this.props;

    logoutUser(cache, checkoutElementPayMode, this.props.subscription, {
      onSelectChange,
      onLoginDataChange,
      onBtnTextChange
    })
      .catch(() => {})
      .then(() => {
        this.setState({ isProcessing: false });
      });
  };

  render({ userDetails }, { isProcessing }) {
    if (!userDetails) {
      return '';
    }

    return (
      <div className="ptm-txt-right">
        <span>{this.label.mobileNumber} </span>
        <span className="ptm-semibold">{userDetails.mobile} </span>
        <span
          className={`ptm-switch-num ${isProcessing ? 'ptm-disbled-cursor' : 'ptm-pointer-cursor'}`}
          onClick={!isProcessing && this.logoutUser}
        >
          {this.label.changeNumber}
        </span>
      </div>
    );
  }
}

export default connect(
  'cache, checkoutElementPayMode, subscription',
  onChange
)(SwitchUser);



// WEBPACK FOOTER //
// ./components/switchUser/index.js